// どのイベントが先でもOK。やることは「preloading を外す」だけ。
(() => {
    const started = performance.now();

    function minMs() {
        // 要素がまだなくても、後で拾えるように両方を見る
        const el = document.querySelector('[data-preloader]');
        const v = parseInt(
            (el && el.dataset.minVisibleMs) || document.documentElement.dataset.minVisibleMs || '',
            10
        );
        return Number.isFinite(v) ? v : 200; // デフォルト 200ms
    }

    function finish() {
        const wait = Math.max(0, minMs() - (performance.now() - started));
        setTimeout(() => {
            document.documentElement.classList.remove('preloading'); // ← これだけ
            // （フェードしたいなら .is-hidden を付けたい要素に追加してもOK）
            const el = document.querySelector('[data-preloader]');
            if (el) el.classList.add('is-hidden');
        }, wait);
    }

    if (document.readyState === 'complete') finish();
    else window.addEventListener('load', finish, { once: true });

    // Alpine/app 側の合図も「早い者勝ち」で受ける
    document.addEventListener('alpine:initialized', finish, { once: true });
    document.addEventListener('app:booted', finish, { once: true });

    // 最終保険
    setTimeout(finish, 3000);
})();
